module.exports = __webpack_public_path__ + "img/icon_shoubi_hover@2x.26bf8005.png";